import EventEmitter from 'eventemitter3';
import { MediaPacket } from '../../proto/messages';
export class MediaPacketDefragmenter extends EventEmitter {
    mediaPacketFragmentMap = new Map();
    feedMediaPacketFragment(mediaPacketFragment) {
        if (mediaPacketFragment.numberOfFragments === 1) {
            const mediaPacket = MediaPacket.fromBinary(mediaPacketFragment.data);
            this.emit('mediaPacket', mediaPacket);
        }
        else {
            this.addMediaPacketFragment(mediaPacketFragment);
            this.tryDefragment();
        }
    }
    addMediaPacketFragment(mediaPacketFragment) {
        const packetNumber = mediaPacketFragment.packetNumber.toString();
        const fragmentNumber = mediaPacketFragment.fragmentNumber;
        const fragments = this.mediaPacketFragmentMap.get(packetNumber) || new Map();
        fragments.set(fragmentNumber, mediaPacketFragment);
        this.mediaPacketFragmentMap.set(packetNumber, fragments);
    }
    tryDefragment() {
        if (this.mediaPacketFragmentMap.size === 0) {
            return;
        }
        // Iterate through all packet numbers
        for (const [packetNumber, fragments] of this.mediaPacketFragmentMap) {
            const firstFragment = fragments.values().next().value;
            if (!firstFragment) {
                continue;
            }
            const expectedNumberOfFragments = firstFragment.numberOfFragments;
            // Check if we have all fragments for this packet
            if (fragments.size !== expectedNumberOfFragments) {
                continue;
            }
            // Combine fragments in order
            const orderedFragments = Array.from(fragments.values()).sort((a, b) => a.fragmentNumber - b.fragmentNumber);
            let dataSize = 0;
            for (const fragment of orderedFragments) {
                dataSize += fragment.data.length;
            }
            const orderedData = new Uint8Array(dataSize);
            let offset = 0;
            for (const fragment of orderedFragments) {
                orderedData.set(fragment.data, offset);
                offset += fragment.data.length;
            }
            // Parse and emit the complete packet
            const mediaPacket = MediaPacket.fromBinary(orderedData);
            this.emit('mediaPacket', mediaPacket);
            // Remove the defragmented packet from the map
            this.mediaPacketFragmentMap.delete(packetNumber);
        }
    }
}
